import {
    api_request,
} from '@/utils/api';
import {
    isDEV,
} from "@/utils/request";

export const endpoint_127 = 'http://127.0.0.1';
export const port_jingbo = '8021'; //孙靖博版本1：8011
export const endpoint_v = `${endpoint_127}:${port_jingbo}`;
export const get_batch_task_list = (func, isDEV1)=>{
    console.log(isDEV1);
    // if(isDEV){
    //     func(require('@/json/Benchmark.json'));
    //     return;
    // }

    api_request({
        url: endpoint_v + '/batch_task/list/IMF3',
        type: 'GET',
        crud_name: '获取线上展示数据',
        success: func
    });
};
export const post_batch_task_list_fix = (key, data, func, isDEV1)=>{
    // key: /question/step/milestone
    // Index（int）: 这个接口给我传【index】就好
    // Question（string）/milestone（List[string]）/ step（List[string]）
    console.log(isDEV1);
    // if(isDEV){
    //     func(require('@/json/Benchmark.json'));
    //     return;
    // }

    api_request({
        data,
        url: endpoint_v + '/batch_task/list/fix/'+key+'/',
        type: 'POST',
        crud_name: '修改' + key,
        success: func
    });
};
export const get_batch_task_tools = (func, isDEV1)=>{
    console.log(isDEV1);
    if(isDEV){
        func(require('@/json/Tools.json'));
        return;
    }
    api_request({
        url: endpoint_v + '/batch_task/list/tool/',
        type: 'GET',
        crud_name: '获取线上展示数据',
        success: func
    });
};
export const get_batch_task = (task_id, func, isDEV1)=>{
    console.log(isDEV1);
    // if(isDEV){
    //     func(require('@/json/BenchmarkDetail.json'));
    //     return;
    // }
    api_request({
        url: endpoint_v + '/batch_task/online/'+task_id+'/',
        type: 'GET',
        crud_name: '获取线上展示数据',
        success: func
    });
};
export const get_task_type_color = (task_type) =>{
    let arr = [
        {name: 'O', color1: '#F7EAB6', color: '#F1AA5A', children: [],},
        {name: 'P', color1: '#E1AFA6', color: '#D25F4A', children: [],},
        {name: 'M', color1: '#B6CCCA', color: '#549090', children: [],},
        {name: 'S', color1: '#B3E7FF', color: '#6BAEFF', children: [],},
        {name: 'V', color1: '#AFA9CF', color: '#525099', children: [],},
    ];
    return arr.find(a=> a.name  === task_type)?.color;
};